import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { EventModel, EventBaseData } from '../../shared/models/event.model';
import { map, filter } from 'rxjs/operators';
import { EventTypes } from 'src/app/shared/enum/event.types';

@Injectable({
  providedIn: 'root'
})
export class EventService {
  public $event: BehaviorSubject<EventModel> = new BehaviorSubject<EventModel>({ Type: EventTypes.BuildNewResultView });

  public broadCast(eventType: EventTypes, data?: EventBaseData): void {
    this.$event.next({ Type: eventType, Data: data });
  }

  public tryListen(eventType: EventTypes, data?: EventBaseData): Observable<any> | undefined | null {
    this.$event.next({ Type: eventType, Data: data });
    return data?.onAction;
  }

  public listen(eventType: EventTypes): Observable<any> {
    return this.$event.asObservable().pipe(
      filter((e) => e !== null && e.Type === eventType),
      map((e) => {
        const res = { ...e.Data };
        if (e.Data) {
          e.Data.isRead = true;
        }
        return res;
      })
    );
  }
}
